import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ew-section-loader',
  templateUrl: './ew-section-loader.component.html',
  styleUrls: ['./ew-section-loader.component.css']
})
export class EwSectionLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
